export default [
  { key: 'None', name: 'None', always_enabled: true },
  { key: 'Fixed', name: 'Fixed Costs Only', always_enabled: true },
  { key: 'VWAP1', name: 'VWAP 1-Day Volume', always_enabled: false },
  { key: 'VWAP3', name: 'VWAP 3-Day Volume', always_enabled: false },
  { key: 'Optimal0.3', name: 'IS Neutral', always_enabled: false },
];